import React from 'react';
import { FormProvider } from 'react-hook-form';
import { styled, useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import useForm from 'common/hooks/useForm';
import FormTextField from 'common/components/input/FormTextField';
import InputAdornment from 'common/components/material/InputAdornment';
import { InlineIconButton } from 'features/org-root/org-root.styles';
import { NamedStaticData } from 'features/static-data/types/static-data.type';
import { HierarchicalExplorerFormProps } from '../types/hierarchical-explorer-form-props.type';

const StyledForm = styled('form')({
  width: '100%',
});

const HierarchicalExplorerForm: React.FC<HierarchicalExplorerFormProps> = ({
  data,
  disabled,
  parentId,
  dataType,
  onChange,
  onClose,
}) => {
  const { palette } = useTheme();
  const form = useForm<NamedStaticData>({
    defaultValues: {
      name: data?.name,
    },
  });

  const handleSubmit = ({ name }: NamedStaticData) => {
    if (disabled) {
      return;
    }

    const dataToSubmit = {
      name,
      id: data?.id,
      type: data?.type || dataType,
      parentId: data?.parentId || parentId,
    };
    onChange && onChange(dataToSubmit);
  };

  return (
    <FormProvider {...form}>
      <StyledForm noValidate onSubmit={form.handleSubmit(handleSubmit)}>
        <FormTextField
          autoFocus
          name="name"
          fullWidth
          disabled={disabled}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <InlineIconButton sx={{ marginRight: '0.25rem' }} type="submit">
                  <CheckIcon sx={{ color: palette.Icons.Tertiary.IconFillDefault }} />
                </InlineIconButton>
                <InlineIconButton onClick={onClose}>
                  <CloseIcon sx={{ color: palette.Icons.Tertiary.IconFillDefault }} />
                </InlineIconButton>
              </InputAdornment>
            ),
          }}
        />
      </StyledForm>
    </FormProvider>
  );
};

export default HierarchicalExplorerForm;
